import { Routes, Route } from "react-router-dom";
import Main from "../pages/Main/Main";
import Home from "../pages/Home/Home";
import CoursePage from "../pages/Course/CoursePage";
import CreateCoursePage from "../pages/Course/CreateCoursePage";
import EditCoursePage from "../pages/Course/EditCoursePage";
import PreviewCoursePage from "../pages/Course/PreviewCoursePage";
import LessonPage from "../pages/Course/LessonPage";
import CreateLessonPage from "../pages/Course/CreateLessonPage";
import EditLessonPage from "../pages/Course/EditLessonPage";
import PreviewLessonPage from "../pages/Course/PreviewLessonPage";
import Live from "../pages/Course/Live/Live";
import { useDispatch, useSelector } from "react-redux";
import { selectUserInformations } from "../features/authSlice";
import useCategoryCrud from "../hooks/CRUD/useCategoryCrud";
import { setCategoryData } from "../features/categories/categorySlice";
import { setInstructorData } from "../features/instructors/instructorSlice";
import { useEffect } from "react";
import { API } from "../shared/api/Api";
import useInstructorCrud from "../hooks/CRUD/useInstructorCrud";
import InstructorPage from "../pages/Instructors/InstructorPage";
import CreateInstructorPage from "../pages/Instructors/CreateInstructorPage";
import EditInstructorPage from "../pages/Instructors/EditInstructorPage";
import PreviewInstructorPage from "../pages/Instructors/PreviewInstructorPage";
import CourseStudentsPage from "../pages/Course/Student/CourseStudentsPage";
import StudentPage from "../pages/Students/StudentPage";
import CreateStudentPage from "../pages/Students/CreateStudentPage";
import EditStudentPage from "../pages/Students/EditStudentPage";
import PreviewStudentPage from "../pages/Students/PreviewStudentPage";
import StudentHistorySearchPage from "../pages/Students/StudentHistorySearchPage";
import InstructorHistorySearchPage from "../pages/Instructors/InstructorHistorySearchPage";
import CoursePaymentPage from "../pages/Course/Payment/CoursePaymentPage";
import PaymentPage from "../pages/Payments/PaymentPage";
import CreatePaymentPage from "../pages/Payments/CreatePaymentPage";
import EditPaymentPage from "../pages/Payments/EditPaymentPage";
import PreviewPaymentPage from "../pages/Payments/PreviewPaymentPage";
import MaterialPage from "../pages/Materials/MaterialPage";
import CreateMaterialPage from "../pages/Materials/CreateMaterialPage";
import PreviewMaterialPage from "../pages/Materials/PreviewMaterialPage";
import CourseMaterialPage from "../pages/Course/Material/CourseMaterialPage";
import RefundPage from "../pages/Refund/RefundPage";
import CreateRefundPage from "../pages/Refund/CreateRefundPage";
import EditRefundPage from "../pages/Refund/EditRefundPage";
import PreviewRefundPage from "../pages/Refund/PreviewRefundPage";
import RolePage from "../pages/Roles/RolePage";
import CreateRolePage from "../pages/Roles/CreateRolePage";
import PreviewRolePage from "../pages/Roles/PreviewRolePage";
import Profile from "../pages/Profile/Profile";
import PermissionPage from "../pages/Roles/Permission/PermissionPage";
import BlogPage from "../pages/Blog/BlogPage";
import RecordingPage from "../pages/Recordings/RecordingPage";
import CategoryPage from "../pages/Category/CategoryPage";
import CreateCategoryPage from "../pages/Category/CreateCategoryPage";
import EditCategoryPage from "../pages/Category/EditCategoryPage";
import PreviewCategoryPage from "../pages/Category/PreviewCategoryPage";
import UserPage from "../pages/User/UserPage";
import CreateUserPage from "../pages/User/CreateUserPage";
import EditUserPage from "../pages/User/EditUserPage";
import PreviewUserPage from "../pages/User/PreviewUserPage";
import BlacklistPage from "../pages/User/BlacklistPage";
import CourseDetailsPage from "../pages/Landing/CourseDetailsPage";
import PurchaseCoursePage from "../pages/Landing/PurchaseCoursePage";
import AnimatedBookLoader from "../components/AnimatedBookLoader/AnimatedBookLoader";
import PlacementTestPage from "../pages/PlacementTest/PlacementTestPage";
import CreatePlacementTestPage from "../pages/PlacementTest/CreatePlacementTestPage";
import PlacementTestDetailsPage from "../pages/PlacementTest/PlacementTestDetailsPage";
import PlacementTestEnrollRedirect from "../pages/PlacementTest/PlacementTestEnrollRedirect";
import EditPlacementTestPage from "../pages/PlacementTest/EditPlacementTestPage";

function DashboardRoutes() {
  const user = useSelector(selectUserInformations);
  const categoryHook = useCategoryCrud(API.Categories, {});
  const instructorHook = useInstructorCrud(API.Instructors, {});
  const dispatch = useDispatch();

  useEffect(() => {
    categoryHook.getAllEntites(user.token, null).then((res) => {
      dispatch(setCategoryData(res));
    });
    instructorHook.getAllEntites(user.token, null).then((res) => {
      dispatch(setInstructorData(res));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, user.token]);

  if (categoryHook.loading || instructorHook.loading)
    return (
      <div className="bg-[#EBEBEB] min-h-screen flex justify-center items-center h-screen">
        <AnimatedBookLoader />
      </div>
    );

  return (
    <Routes>
      <Route path="/dashboard" element={<Main />}>
        <Route path="home" element={<Home />} />
        <Route path="profile" element={<Profile />} />
        <Route path="courses" element={<CoursePage />} />
        <Route path="courses/create" element={<CreateCoursePage />} />
        <Route path="courses/:id" element={<PreviewCoursePage />} />
        <Route path="courses/:id/edit" element={<EditCoursePage />} />
        <Route path="students" element={<StudentPage />} />
        <Route path="students/create" element={<CreateStudentPage />} />
        <Route path="students/history" element={<StudentHistorySearchPage />} />
        <Route path="students/:id" element={<PreviewStudentPage />} />
        <Route path="students/:id/edit" element={<EditStudentPage />} />
        <Route path="instructors" element={<InstructorPage />} />
        <Route path="instructors/create" element={<CreateInstructorPage />} />
        <Route path="instructors/history" element={<InstructorHistorySearchPage />} />
        <Route path="instructors/:id" element={<PreviewInstructorPage />} />
        <Route path="instructors/:id/edit" element={<EditInstructorPage />} />
        <Route path="payments" element={<PaymentPage />} />
        <Route path="payments/create" element={<CreatePaymentPage />} />
        <Route path="payments/:id" element={<PreviewPaymentPage />} />
        <Route path="payments/:id/edit" element={<EditPaymentPage />} />
        <Route path="materials" element={<MaterialPage />} />
        <Route path="materials/create" element={<CreateMaterialPage />} />
        <Route path="materials/:id" element={<PreviewMaterialPage />} />
        <Route path="courses/:courseId/materials/create" element={<CreateMaterialPage />} />
        <Route path="refunds" element={<RefundPage />} />
        <Route path="refunds/create" element={<CreateRefundPage />} />
        <Route path="refunds/:id" element={<PreviewRefundPage />} />
        <Route path="refunds/:id/edit" element={<EditRefundPage />} />
        <Route path="courses/lesson/:id" element={<LessonPage />} />
        <Route path="courses/:courseId/lessons/create" element={<CreateLessonPage />} />
        <Route path="courses/:courseId/lessons/:id" element={<PreviewLessonPage />} />
        <Route path="courses/:courseId/lessons/:id/edit" element={<EditLessonPage />} />
        <Route path="courses/details/:id" element={<CourseDetailsPage />} />
        <Route path="courses/:id/purchase" element={<PurchaseCoursePage />} />
        <Route path="courses/:id/payment" element={<CoursePaymentPage />} />
        <Route path="courses/:id/student" element={<CourseStudentsPage />} />
        <Route path="courses/:id/material" element={<CourseMaterialPage />} />
        <Route path="live/records" element={<RecordingPage />} />
        <Route path="courses/lesson/live/:id" element={<Live />} />
        <Route path="instructors" element={<InstructorPage />} />
        <Route path="roles" element={<RolePage />} />
        <Route path="roles/create" element={<CreateRolePage />} />
        <Route path="roles/:id" element={<PreviewRolePage />} />
        <Route path="blog" element={<BlogPage />} />
        <Route path="permissions" element={<PermissionPage />} />
        <Route path="categories" element={<CategoryPage />} />
        <Route path="categories/create" element={<CreateCategoryPage />} />
        <Route path="categories/:id" element={<PreviewCategoryPage />} />
        <Route path="categories/:id/edit" element={<EditCategoryPage />} />
        <Route path="users" element={<UserPage />} />
        <Route path="users/create" element={<CreateUserPage />} />
        <Route path="users/blacklist" element={<BlacklistPage />} />
        <Route path="users/:id" element={<PreviewUserPage />} />
        <Route path="users/:id/edit" element={<EditUserPage />} />
        
        {/* Placement Test Routes */}
        <Route path="placement-tests" element={<PlacementTestPage />} />
        <Route path="placement-tests/create" element={<CreatePlacementTestPage />} />
        <Route path="placement-tests/:id" element={<PlacementTestDetailsPage />} />
        <Route path="placement-tests/:id/edit" element={<EditPlacementTestPage />} />
        <Route path="placement-tests/:id/enroll" element={<PlacementTestEnrollRedirect />} />
      </Route>

    </Routes>
  );
}

export default DashboardRoutes;
